import React, { useEffect, useState, useRef } from "react";
import SettingLayout from "../Components/SettingLayout";
import {
  Button,
  Flex,
  Form,
  Input,
  FormInstance,
  notification,
  Checkbox,
} from "antd";
import RolePermissionTable from "../Components/RolePermissionTable";
import { useNavigate } from "react-router-dom";
import { mixGetV1, mixPostV1 } from "../../../services/mixin";
import { useParams } from "react-router-dom";

const RolePermissionEdit: React.FC = () => {
  const navigate = useNavigate();
  const formRef = useRef<FormInstance>(null);
  const [roleList, setRoleList] = useState<any[]>([]);
  let waitx = false;
  const { id } = useParams();
  const getDetail = async () => {
    if (waitx) {
      return;
    }
    waitx = true;
    const res = await mixGetV1("/api/webAdmin/gInfoPermissionByRole.php", {
      role_id: id,
    });
    waitx = false;
    if (res.status === 1) {
      setRoleList(res.data.permission);
      formRef?.current?.setFieldValue("role_name", res.data.role_name);
      formRef?.current?.setFieldValue(
        "can_view_customer_phone",
        res?.data?.can_view_customer_phone &&
          res?.data?.can_view_customer_phone === 1
          ? true
          : false,
      );
      formRef?.current?.setFieldValue(
        "can_view_report_income",
        res?.data?.can_view_report_income &&
          res?.data?.can_view_report_income === 1
          ? true
          : false,
      );
      formRef?.current?.setFieldValue(
        "can_register_new_member",
        res?.data?.can_register_new_member &&
          res?.data?.can_register_new_member === 1
          ? true
          : false,
      );
      formRef?.current?.setFieldValue(
        "can_delete_member",
        res?.data?.can_delete_member && res?.data?.can_delete_member === 1
          ? true
          : false,
      );
      formRef?.current?.setFieldValue(
        "can_view_weekly_report",
        res?.data?.can_view_weekly_report &&
          res?.data?.can_view_weekly_report === 1
          ? true
          : false,
      );
      formRef?.current?.setFieldValue(
        "can_view_machine_income",
        res?.data?.can_view_machine_income &&
          res?.data?.can_view_machine_income === 1
          ? true
          : false,
      );
      formRef?.current?.setFieldValue(
        "can_view_payout_report",
        res?.data?.can_view_payout_report &&
          res?.data?.can_view_payout_report === 1
          ? true
          : false,
      );
      formRef?.current?.setFieldValue(
        "view_staff_report",
        res?.data?.view_staff_report && res?.data?.view_staff_report === 1
          ? true
          : false,
      );
    } else {
      navigate("/setting/role-permission");
    }
  };
  useEffect(() => {
    getDetail();
  }, []);
  const changeRole = (data: any) => {
    let tempData = { ...data };
    const temp = [...roleList];
    temp.map((item, index) => {
      if (item.function_id === tempData.function_id) {
        if (tempData.iskey && tempData.iskey === "is_full") {
          tempData = {
            ...item,
            is_full: tempData.is_full,
            is_view: tempData.is_full,
            is_create: tempData.is_full,
            is_edit: tempData.is_full,
            is_delete: tempData.is_full,
          };
          delete tempData.iskey;
          temp[index] = tempData;
        } else {
          temp[index] = tempData;
        }
      }
      return true;
    });
    setRoleList(temp);
  };
  const onSubmitForm = () => {
    if (formRef && formRef.current) {
      formRef?.current?.submit();
    }
  };
  const onFinish = async (values: any) => {
    const can_view_customer_phone = values?.can_view_customer_phone ? 1 : 0;
    const can_view_report_income = values?.can_view_report_income ? 1 : 0;
    const can_register_new_member = values?.can_register_new_member ? 1 : 0;
    const can_delete_member = values?.can_delete_member ? 1 : 0;
    const can_view_weekly_report = values?.can_view_weekly_report ? 1 : 0;
    const can_view_machine_income = values?.can_view_machine_income ? 1 : 0;
    const can_view_payout_report = values?.can_view_payout_report ? 1 : 0;
    const view_staff_report = values?.view_staff_report ? 1 : 0;

    const res = await mixPostV1("/api/webAdmin/editPermissionUserByrole.php", {
      role_id: id,
      role_name: values.role_name,
      can_view_customer_phone,
      can_view_report_income,
      can_register_new_member,
      can_delete_member,
      can_view_weekly_report,
      can_view_machine_income,
      can_view_payout_report,
      view_staff_report,
      permissionList: JSON.stringify(roleList),
    });
    if (res.status === 1) {
      navigate("/setting/role-permission");
    } else {
      openNotification("error", res.message);
    }
  };

  // NOTIFICATION
  const [api, contextHolder] = notification.useNotification();
  const openNotification = (
    type: "success" | "info" | "warning" | "error" = "success",
    message = "Role & permission updated!",
  ) => {
    api[type]({
      message: message,
      placement: "bottomRight",
      className: "single-message",
    });
  };

  return (
    <SettingLayout current="role-permission">
      {contextHolder}
      <div className="setting-content setting-content--update setting-device">
        <div className="mw-687">
          <Form
            ref={formRef}
            name="add-role-form"
            onFinish={onFinish}
            layout="vertical"
            className="rs-form form-gap-12"
          >
            <Form.Item
              name="role_name"
              label="Role name"
              rules={[{ required: true, message: "Please filled this field" }]}
            >
              <Input
                placeholder="Example: Admin, manager, staff, ..."
                className="rs-input"
              />
            </Form.Item>
            <div className="d-flex">
              <Form.Item
                name="can_view_customer_phone"
                valuePropName="checked"
                className="mt-4 rs-form form-gap-12"
              >
                <Checkbox className="rs-input">Show customer phone</Checkbox>
              </Form.Item>
              <Form.Item
                name="can_register_new_member"
                valuePropName="checked"
                className="mt-4 rs-form form-gap-12"
              >
                <Checkbox className="rs-input">
                  Allow new member registration
                </Checkbox>
              </Form.Item>
              <Form.Item
                name="can_view_report_income"
                valuePropName="checked"
                className="mt-4 rs-form form-gap-12"
              >
                <Checkbox className="rs-input">
                  View report total income
                </Checkbox>
              </Form.Item>
            </div>
            <div className="d-flex">
              <Form.Item
                name="can_view_weekly_report"
                valuePropName="checked"
                className="mt-4 rs-form form-gap-12"
              >
                <Checkbox className="rs-input">View weekly report</Checkbox>
              </Form.Item>
              <Form.Item
                name="can_view_machine_income"
                valuePropName="checked"
                className="mt-4 rs-form form-gap-12"
              >
                <Checkbox className="rs-input">View Machine Income</Checkbox>
              </Form.Item>
              <Form.Item
                name="can_view_payout_report"
                valuePropName="checked"
                className="mt-4 rs-form form-gap-12"
              >
                <Checkbox className="rs-input">View Payout Report</Checkbox>
              </Form.Item>
            </div>
            <div className="d-flex">
              <Form.Item
                name="view_staff_report"
                valuePropName="checked"
                className="mt-4 rs-form form-gap-12"
              >
                <Checkbox className="rs-input">View Staff Report</Checkbox>
              </Form.Item>
              <Form.Item
                name="can_delete_member"
                valuePropName="checked"
                className="mt-4 rs-form form-gap-12"
                hidden
              >
                <Checkbox className="rs-input">Allow delete member</Checkbox>
              </Form.Item>
            </div>

            <RolePermissionTable
              roleList={roleList}
              changeRole={(data: any) => changeRole(data)}
            />
          </Form>
        </div>

        <Flex gap={24} align="center">
          <Button
            className="rs-button default-outlined button-update"
            onClick={() => navigate("/setting/role-permission")}
          >
            Cancel
          </Button>
          <Button
            onClick={onSubmitForm}
            className="rs-button button-update"
            type="primary"
          >
            Update
          </Button>
        </Flex>
      </div>
    </SettingLayout>
  );
};

export default RolePermissionEdit;
